export default {
  generalError: 'Something went wrong, please try again later',
};
